'use client';

import { motion } from 'framer-motion';

export default function Illustration2({ className = '' }: { className?: string }) {

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, scale: 0.8 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    return (
        <motion.svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 307.03 304.15"
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={containerVariants}
        >
            <defs>
                <style>{`.cls-1 { fill: #ffb53e; } .cls-2 { fill: #2283ba; }`}</style>
            </defs>
            <motion.g id="Layer_1-2" data-name="Layer 1" variants={containerVariants}>
                <g>
                    <motion.polygon
                        variants={itemVariants}
                        className="cls-1"
                        points="287.13 75.72 261.28 119.36 307.03 141.25 264.8 169.35 296.52 208.93 246.28 215.93 257.69 265.35 209.39 249.85 198.23 299.33 161.43 264.42 129.91 304.15 111.91 256.73 66.26 278.85 70.62 228.31 19.9 228.43 45.75 184.79 0 162.9 42.23 134.8 10.51 95.22 60.75 88.22 49.34 38.8 97.64 54.3 108.81 4.82 145.6 39.73 177.13 0 195.12 47.42 240.77 25.3 236.41 75.84 287.13 75.72"
                    />
                    <motion.path
                        variants={itemVariants}
                        className="cls-2"
                        d="M169.51,159.73l-3.25,46.3-61.99-4.35c13.92-14.59,27.72-23.85,37.66-29.51,10.47-5.96,19.92-9.79,27.58-12.44Z"
                    />
                    <motion.path
                        variants={itemVariants}
                        className="cls-2"
                        d="M146.01,100.7c2.92,2.77,2.55,6.56,2.5,6.97-1.23,18.39-2.46,36.78-3.69,55.17l25.4-13.27,4.78-67.98-34.79,8.94-.56,7.96c.51-.04,3.76-.26,6.36,2.21Z"
                    />
                </g>
            </motion.g>
        </motion.svg>
    );
}
